<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="modalTitle || $schema.$title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="submit"
    @close="close"
  >
    <w-datepicker :model="$schema.date" :title="dateTitle" />

    <checkbox-list class="mt-4" :model="$schema.packIds" :options="packs" />
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import CheckboxList from '@/components/formComponents/CheckboxList';
import { Errors } from '@/enums/errors.enum';
import { PaymentState } from '@/enums/paymentState';
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/paymentPackMultiplePaid.schema';

// @vuese
// Modal ustawiania "Środki wypłacone" dla wielu paczek
// @group Modals
export default {
  components: { CheckboxList },
  mixins: [formMixin, notificationsMixin, modalMixin],

  props: {
    // Nadpisanie tytułu modala
    modalTitle: { type: String, required: false },

    // Nadpisanie tytułu pola z datą
    dateTitle: { type: String, required: false },

    // Status paczek do filtrowania
    status: { type: String, default: PaymentState.LIST_SENT }
  },

  schema,

  data() {
    return { model: {} };
  },

  computed: mapState({
    packs(state) {
      return state.paymentPack.list
        .filter(pack => pack.status === this.status)
        .map(pack => ({ text: pack.number, value: pack.id }));
    }
  }),

  methods: {
    submit() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }
      this.$emit('submit', this.$schema.$getData());
    }
  }
};
</script>

<style>
.packs {
  display: flex;
}
</style>
